import {AxiosResponse, AxiosError} from 'axios';

// error type to reject
export interface APIErrorData {
  status?: number;
  message: string;
  err?: object;
}

export const successHandler = (response: AxiosResponse): Promise<AxiosResponse> => {
  const {status, data} = response;

  // Some endpoints return HTTP 2xx with { error: "message" } for business failures
  if (
    status < 300 &&
    data &&
    typeof (data as {error?: unknown}).error === 'string' &&
    (data as {error: string}).error.length > 0
  ) {
    return Promise.reject({
      status,
      message: (data as {error: string}).error,
      err: (data as {error: string}).error,
    });
  }

  // Return the entire response object instead of just the data
  // This preserves the .data property that your code expects
  if (status < 300 && !data.err) {
    return Promise.resolve(response); // Return full response with .data property
  } else if (data.err && data.err.ec === 0) {
    // If you need to transform the data but keep .data structure, do:
    const modifiedResponse = {...response};
    modifiedResponse.data = data.ret;
    return Promise.resolve(modifiedResponse);
  }

  // add early error handling here like 401 redirection(error code in success response)
  else if (data.err && data.err.ec !== 0) {
    return Promise.reject({
      status: data.err.ec,
      message: data.err.em || data.err.dm,
      err: data.err,
    });
  }
  return Promise.reject({
    status,
    message: 'request failed with no content',
  });
};

export const failureHandler = (error: AxiosError): Promise<APIErrorData | null> => {
  const {response} = error;
  const {status, data}: any = response || {};

  if (data && data.error) {
    return Promise.reject({
      status,
      message: data.error, // Extract the error message from the response
      err: data.error,
    });
  }

  if (status === 401 && window.location.pathname.indexOf('/login') === -1) {
    // In this condition, it require all failure handler in "action" or anywhere to check whether the error exists
    return Promise.reject(null);
  }
  if (status === 403) {
    console.warn('Session expired or access forbidden');
    // Clear authentication data
    localStorage.removeItem('token');
    localStorage.removeItem('userId');

    // Use a timeout to ensure the redirect happens after the current execution context
    setTimeout(() => {
      window.location.href = '/login';
    }, 0);

    // Return a rejected promise without showing error messages
    return Promise.reject(null);
  }
  return Promise.reject({
    status,
    message: data?.message || error?.message || 'request failed with no response',
  });
};
